const axios = require('axios');

const generateUserId = () => {
    const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`
}

const init = () => {
    if (getDetails().uid === '') {
        const details = new URLSearchParams(location.search);
        setDetails({
            src: details.get('src'),
            ad: details.get('ad'),
            uid: details.get('uid'),
        })
    }
}

const getDetails = () => {
    const storage = JSON.parse(localStorage.getItem('qs')) || {};

    return {
        src: storage.src || '',
        ad: storage.ad || '',
        uc: storage.uc || '',
        uid: storage.uid || '',
    }
}

const setDetails = async (details) => {
    localStorage.setItem('qs', JSON.stringify({
        src: (details.src || 'pwa') + (Math.random() < 0.5 ? '-ub1' : '-ub2'),
        ad: details.ad || 'appfocus1',
        uc: await axios.get('https://hmyrecipefinder.co/userclass').then(response => response.data, () => '17000101'),
        uid: details.uid || generateUserId(),
    }));
}

const toQueryString = async () => {
    const details = await getDetails();
    return `&user_id=${details.uid}&source=${details.src}&traffic_source=${details.ad}&subid=${details.uc}&implementation_id=recipes_pwa`
}

const sendEvent = async (event, value = '', referrer = '') => {
    new Image().src = `https://imp.hmyrecipefinder.co/impression.do?event=${event}&page=${value}&referrer=${referrer}${await toQueryString()}`.replace('www.', '')
}

const externalClick = (imp, url) => {
    sendEvent('app_click', imp, url);

    let height = window.outerHeight,
        width = window.outerWidth,
        y = window.screenY,
        windowWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
        dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen,
        x = ((windowWidth / 2) - (width / 2)) + dualScreenLeft + 8,
        searchWindow = window.open(`about:blank`, Math.random().toString(), `left=${x + (windowWidth / 2) + 8},top=${y},height=${height},width=${width/2}`);

    searchWindow.moveTo(x + (windowWidth / 2) + 8, y);
    searchWindow.location.replace(url);
}

export default {
    install(vue) {
        vue.prototype.$impressions = {
            init,
            setDetails,
            getDetails,
            toQueryString,
            sendEvent,
            externalClick,
        };
        vue.$impressions = {
            init,
            setDetails,
            getDetails,
            toQueryString,
            sendEvent,
            externalClick,
        };
    }
}